import * as ACTION_TYPES from './actionTypes';

import { IAPInvoiceActions, IAPInvoiceState } from './types';

const initialState: IAPInvoiceState = {
  items: [],
  has_more: false,
  itemView: {},
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, action: IAPInvoiceActions)  => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_AP_INCOICE_SUCCESS:
      return {
        ...state,
        items: action.payload,
      };
    case ACTION_TYPES.FETCH_AP_INCOICE_VIEW_SUCCESS:
      return {
        ...state,
        itemView: action.payload,
      };
    default:
      return state;
  }
};